import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { Panel, Hr, Row, Margin, Table, Text } from 'shared/components'

import { BeneficiaryFilters } from './components/filters'
import { SelectorComponent } from './components/selector'
import { MobileBeneficiariesLayout } from './components/mobileBeneficiariesLayout'

const BeneficiariesComponent = ({
  columns,
  favoriteColumns,
  onSearch,
  loadBeneficiaries,
  loadFavoriteBeneficiaries,
  loadCategories,
  followerService,
}) => {
  const [isFavorite, setIsFavorite] = useState(true)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      // Show mobile layout for devices up to 767px (phones)
      setIsMobile(window.innerWidth <= 767)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)

    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  const onClick = () => {
    setIsFavorite(!isFavorite)
  }

  // Render mobile layout for mobile devices
  if (isMobile) {
    return (
      <MobileBeneficiariesLayout
        loadBeneficiaries={loadBeneficiaries}
        loadFavoriteBeneficiaries={loadFavoriteBeneficiaries}
        loadCategories={loadCategories}
        onSearch={onSearch}
        followerService={followerService}
      />
    )
  }
  return (
    <Panel>
      <Text as="h1" size={18} bold>
        Beneficiaries
      </Text>
      <Margin tb={3}>
        <Hr width="full" />
      </Margin>
      <Margin left={2} bottom={3}>
        <Row>
          <SelectorComponent isFavorite={isFavorite} onClick={onClick} />
        </Row>
      </Margin>

      {isFavorite ? (
        <Table
          id="favorite-beneficiaries-table"
          columns={favoriteColumns}
          loadData={loadFavoriteBeneficiaries}
        />
      ) : (
        <>
          <Margin tb={3}>
            <BeneficiaryFilters debounce={250} onSearch={onSearch} />
          </Margin>
          <Table
            id="beneficiaries-table"
            columns={columns}
            loadData={loadBeneficiaries}
          />
        </>
      )}
    </Panel>
  )
}

BeneficiariesComponent.propTypes = {
  query: PropTypes.any,
  columns: PropTypes.arrayOf(PropTypes.shape()),
  favoriteColumns: PropTypes.arrayOf(PropTypes.shape()),
  onSearch: PropTypes.func,
  loadBeneficiaries: PropTypes.func,
  loadFavoriteBeneficiaries: PropTypes.func,
  loadCategories: PropTypes.func,
  followerService: PropTypes.object,
}

export default BeneficiariesComponent
